<template>
  <div id="sovdetailedhuggies" style="text-transform: capitalize">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">
        <!-- <div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate2" />
  	 		</div> -->
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.startDate2"
          />
        </div>

        <div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
            <optgroup label="Retail">
              <option value="https://www.amazon.in">Amazon</option>
              <option value="https://www.flipkart.com">Flipkart</option>
            </optgroup>
          </select>
        </div>
        <div class="datebox">
          <select v-model="device" @change="refresh" class="form-control text-uppercase">
            <option v-if="selected_website == 'https://www.amazon.in'" value="diapers">
              Diapers
            </option>
            <option v-if="selected_website == 'https://www.flipkart.com'" value="diapers">
              Diapers
            </option>
          </select>
        </div>
        <div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size: 13px">Submit</span>
          </button>
        </div>
      </div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float: right">
          <button
            @click="backToSov"
            style="width: max-content; float: right"
            class="btn btn-block weavrpurple"
            type="button"
          >
            <i class="fa fa-arrow-left"></i>
            <span style="font-size: 13px"> Back</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div style="display: flow-root">
        <button
          style="margin-bottom: 10px"
          class="weavrpurple"
          @click="filterAddAction"
          v-if="!addFilter"
        >
          Add Filter
        </button>
        <button
          @click="exportNow"
          style="margin-bottom: 10px; float: right"
          class="weavrpurple"
        >
          Export
        </button>
      </div>
      <div
        v-if="addFilter"
        class="card p-2 filter"
        style="padding: 21px !important; background: #f5f5f5"
      >
        <div class="row mt-2" v-for="(d, i) in filterRow">
          <div class="col-md-2 pr-0">
            <select v-model="d.filterKey" class="form-control text-uppercase">
              <option value="price">Price</option>
              <option value="reviews">Reviews</option>
              <option value="ratings">Ratings</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
            <select v-model="d.filterCondition" class="form-control text-uppercase">
              <option value="equals">Equals to (=)</option>
              <option value="gt">Greater than (&gt;)</option>
              <option value="gte">Greater than equals to (&gt;=)</option>
              <option value="lt">Lower than</option>
              <option value="lte">Lower than equals to (&lt;=)</option>
              <option value="between">Between (&gt;= &amp;&amp; &lt;=)</option>
            </select>
          </div>
          <div class="col-md-2 pr-0">
            <input
              v-model="d.val1"
              class="form-control filval"
              type="text"
              placeholder=""
            />
            <input
              v-if="d.filterCondition == 'between'"
              v-model="d.val2"
              class="form-control filval mt-2"
              type="text"
              placeholder=""
            />
          </div>

          <div class="col-md-2">
            <button @click="filterRemove(i)" class="btn filval btn-danger">Remove</button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 pt-4" style="text-align: center">
            <button @click="filterApply" class="btn filval btn-primary mr-2">
              Apply Filter
            </button>
            <button
              v-if="filterRow.length < 3"
              @click="filterAddMore"
              class="btn filval btn-success mr-2"
            >
              Add more
            </button>
            <button class="btn filval btn-danger" @click="filterCancel">Cancel</button>
          </div>
        </div>
      </div>
      <div class="">
        <div class="card p-2">
          <div class="amd-legend">
            <!-- <div class="legending">
              <input style="margin-top: 4.2px;float: left;margin-right: 3px;" type="checkbox" @change="showHeroChange" v-model="isHero"/>  Hero SKUs
            </div> -->
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9 !important"></i>
              <span>huggies</span>
            </div>
          </div>
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group">
              <tr>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
              </tr>
            </tfoot>
            <tbody class="tbody-normal">
              <tr
                v-for="(r, i) in rows_details"
                :key="i"
                :class="{ markitamd: r['brand'] == 'huggies' }"
              >
                <td
                  :data-order="getDataOrder(r[d.field])"
                  v-for="d in columns_details"
                  :key="d.field"
                >
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{ r[d.field] }}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span v-if="d.field == 'processor' && r['processor'] == 'amd'">{{
                        r[d.field].toUpperCase()
                      }}</span>
                      <span v-else>{{ r[d.field] }}</span>
                    </span>
                    <span v-else>-</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <b-modal size="lg" title="Audit" v-model="showAuditModal">
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columnsAudit"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'compliance_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'position_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'sku_score'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="(Compliance Score + Position Score + Rating Score)/3"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'rating_score'">
                <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn>
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columnsAudit"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ r[d.field] }}
            </td>
          </tr>
        </tbody>
      </table>
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columns_category"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'category_13_position'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 "
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'search_13_position'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 "
                  >?</b-btn
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columns_category"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th
              v-for="d in columns_compliance"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              {{ d.label }}
              <span v-if="d.field == 'logo'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'image_count'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'nomenclature'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature"
                  >?</b-btn
                >
              </span>
              <span v-if="d.field == 'message'">
                <b-btn
                  class="hint"
                  v-b-tooltip.hover
                  title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging"
                  >?</b-btn
                >
              </span>
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal">
          <tr v-for="(r, i) in rowsAudit" :key="i">
            <td
              v-for="d in columns_compliance"
              :key="d.field"
              style="border: 1px solid silver !important"
            >
              <span> {{ r[d.field] }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "sovdetailedhuggies",
  components: { Datepicker },
  data: function () {
    return {
      selected_website: "https://www.amazon.in",
      device: "diapers",
      date: {
        startDate: "2022-07-21",
        startDate2: "2022-07-26",
      },
      oem_websites: [
        "https://fmv.fccl.fujitsu.com",
        "https://www.lenovo.com/au",
        "https://www8.hp.com/jp#commercial",
        "https://www.nec-lavie.jp",
        "https://b2b.lenovo.com.cn#commercial",
        "https://www.lenovo.com/jp#commercial",
        "https://www.hpstore.cn#commercial",
        "https://www.asus.com/fr",
        "https://br-store.acer.com",
        "https://s.lenovo.com.cn",
        "https://store.hp.com/mx-es",
        "https://store.hp.com/FranceStore",
        "https://www.lenovo.com/fr",
        "https://www.insight.com/en-US",
        "https://store.hp.com/FranceStore#commercial",
        "https://www.lenovo.com/fr#commercial",
        "https://www.cdw.com",
        "https://www.lenovo.com/gb#commercial",
        "https://store.hp.com/UKStore#commercial",
        "https://www.lenovo.com/de#commercial",
        "https://store.hp.com/GermanyStore#commercial",
        "https://www8.hp.com/jp",
        "https://store.hp.com/us#commercial",
        "https://www.lenovo.com/us#commercial",
        "https://store.hp.com/UKStore",
        "https://store.hp.com/us",
        "https://store.asus.com/us",
        "https://www.dell.com/en-us",
        "https://store.acer.com/en-us",
        "https://www.lenovo.com/us",
        "https://www.lenovo.com/gb",
        "https://www.lenovo.com/de",
      ],
      columns_details: [],
      rows: [],
      rows_details: [],
      page: 1,
      showAuditModal: false,
      columnsAudit: [
        { label: "SKU", field: "sku", sortable: false },
        { label: "Compliance Score", field: "compliance_score", sortable: false },
        { label: "Position Score", field: "position_score", sortable: false },
        { label: "Rating Score", field: "rating_score", sortable: false },
        { label: "SKU Score", field: "sku_score", sortable: false },
      ],
      columns_category: [
        { label: "Category Position", field: "category_position", sortable: false },
        {
          label: "Category page position (1-3)",
          field: "category_13_position",
          sortable: false,
        },
        { label: "Search Position", field: "search_position", sortable: false },
        { label: "Search (1-3) Position", field: "search_13_position", sortable: false },
      ],
      columns_compliancemex: [
        { label: "Product Logo", field: "logo", sortable: false },
        { label: "OEM Images", field: "image_count", sortable: false },
        { label: "Nomenclature", field: "nomenclature", sortable: false },
        { label: "Message", field: "message", sortable: false },
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      deviceMapper: {
        diapers: "Diapers",
      },
      filterRow: [],
      addFilter: false,
      filterKey: "price",
      filterCondition: "equals",
      filterVal1: "",
      filterVal2: "",
    };
  },
  watch: {
    selected_website: function () {
      this.device = "diapers";
      if (this.selected_website != "https://www.flipkart.com") this.device = "diapersr";
      this.refresh();
    },
  },
  mounted() {
    this.device = "diapers";
    if (this.selected_website != "https://www.flipkart.com") this.device = "diapers";
    this.website_details();
    this.initCols();
  },
  methods: {
    exportNow() {
      let self = this;
      self.loader = true;
      let header = [{ key: "item_id", label: "SKU" }];
      for (let [idx, datasemext] of self.columns_details.entries()) {
        let obj = {};
        obj["key"] = dataset.field;
        obj["label"] = dataset.label;
        header.push(obj);
      }
      let payload = {};
      payload.header = header;
      payload.file_type = "category";
      payload.data = [];
      let dtData = $("#myTable2").DataTable().rows({ filter: "applied" }).data();
      $.each(dtData, function (index, value) {
        let obj = {};
        for (let [idx, dataset] of self.columns_details.entries()) {
          obj[dataset.field] = value[idx]["@data-order"].replace(/<(.|\n)*?>/g, "");
        }
        payload.data.push(obj);
      });
      const url = "/api/websites/export";
      this.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          window.location = response.body.file;
        },
        (err) => {
          self.loader = false;
        }
      );
    },
    getDataOrder(d) {
      if (typeof d == "string" && d.includes(".–")) {
        return "<span>" + d.replace(".–", "") + "</span>";
      }
      return "<span>" + d + "</span>";
    },
    filterCancel() {
      let self = this;
      $("#myTable2").DataTable().destroy();
      this.addFilter = false;
      this.filterRow = [];
      this.rows_details = [];
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        this.rows_details.push(dataset);
      }
      this.$nextTick(function () {
        self.initDt2();
      });
    },
    filterRemove(i) {
      this.filterRow.splice(i, 1);
    },
    filterAddAction() {
      this.addFilter = true;
      let obj = {};
      obj.filterKey = "price";
      obj.filterCondition = "equals";
      obj.val1 = "";
      obj.val2 = "";
      this.filterRow.push(obj);
    },
    filterAddMore() {
      let obj = {};
      obj.filterKey = "price";
      obj.filterCondition = "equals";
      obj.val1 = "";
      obj.val2 = "";
      this.filterRow.push(obj);
    },

    filterCheck(dataset) {
      let operators = {
        equals: function (a, b, c) {
          return a == b;
        },
        gt: function (a, b, c) {
          return a > b;
        },
        gte: function (a, b, c) {
          return a >= b;
        },
        lt: function (a, b, c) {
          return a < b;
        },
        lte: function (a, b, c) {
          return a <= b;
        },
        between: function (a, b, c) {
          if (!c) return a >= b;
          if (!b) return a <= c;

          return a >= b && a <= c;
        },
      };
      for (let [fi, fd] of this.filterRow.entries()) {
        if (!fd.val1) {
          if (fi == this.filterRow.length - 1) {
            return true;
          } else {
            continue;
          }
        }

        if (typeof dataset[fd.filterKey] == "string")
          dataset[fd.filterKey] = dataset[fd.filterKey]
            .replace(".–", "")
            .replace("$", "")
            .replace(" ", "")
            .replace(",", "")
            .replace(",", "");
        dataset[fd.filterKey] = parseFloat(dataset[fd.filterKey]);
        dataset[fd.val1] = parseFloat(dataset[fd.val1]);
        dataset[fd.val2] = parseFloat(dataset[fd.val2]);
        if (
          operators[fd.filterCondition](dataset[fd.filterKey], fd.val1, fd.val2) == false
        ) {
          return false;
        }
      }
      return true;
    },
    filterApply() {
      let self = this;
      $("#myTable2").DataTable().destroy();
      this.rows_details = [];
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (this.filterCheck(dataset)) {
          this.rows_details.push(dataset);
        }
      }
      this.$nextTick(function () {
        self.initDt2();
      });
    },
    initCols() {
      if (this.oem_websites.includes(this.selected_website)) {
        this.columns_details = [
          { label: "SKU", field: "item_id" },
          { label: "Rank", field: "order" },
          { label: "Page", field: "page" },
          { label: "Brand", field: "brand" },
          { label: "Name", field: "product_name", sortable: false },
          { label: "Price", field: "price", sortable: false },
          { label: "Offer", field: "offer", sortable: false },
          { label: "Reviews", field: "reviews" },
          { label: "Ratings", field: "ratings" },
        ];
      } else {
        this.columns_details = [
          { label: "SKU", field: "item_id" },
          { label: "Rank", field: "order" },
          { label: "Page", field: "page" },
          { label: "Brand", field: "brand" },
          { label: "Name", field: "product_name", sortable: false },
          { label: "Price", field: "price", sortable: false },
          { label: "Offer", field: "offer", sortable: false },
          { label: "Reviews", field: "reviews" },
          { label: "Ratings", field: "ratings" },
        ];
      }

      if (this.date.startDate != this.date.startDate2) {
        this.columns_details.splice(0, 2);
      }
    },
    backToSov() {
      window.location = "#/sov-huggies";
    },
    showHeroChange() {
      let self = this;
      $("#myTable2").DataTable().destroy();
      this.rows_details = [];
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (self.isHero) {
          if (dataset.is_hero) {
            this.rows_details.push(dataset);
          }
        } else this.rows_details.push(dataset);
      }
      this.$nextTick(function () {
        self.initDt2();
      });
    },

    openAuditModal(r) {
      let self = this;
      self.rowsAudit = [];
      self.showAuditModal = true;
      self.rowsAudit.push(r.audit);
    },

    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      $("#myTable2").DataTable().destroy();
      this.initCols();
      localStorage.selected_website = this.selected_website;
      localStorage.selected_category = this.device;
      this.website_details();
    },

    website_details() {
      let self = this;
      self.loader = true;
      this.rows_details = [];
      this.rows_details_full = [];
      let payload = {
        website: this.selected_website,
        timestamp: "2022-07-26",
        start_date: "2022-07-26",
      };
      payload["item_category"] = self.device;
      const url = "/api/websites/details";
      this.$http.post(url, payload).then(
        (response) => {
          for (let [idx, ds] of response.body.data.entries()) {
            if (ds.product_name)
              ds.product_name = ds.product_name.replace('"', "'").replace("&amp;", "&");
            if (ds.brand == "hp") ds.brand = "HP";
            self.rows_details.push(ds);
            self.rows_details_full.push(ds);
          }
          self.loader = false;
          self.$nextTick(function () {
            self.initDt2();
          });
        },
        (err) => {
          self.loader = false;
        }
      );
    },

    changeCustomDate() {
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
      if (this.date.startDate2)
        this.date.startDate2 = moment(this.date.startDate2).format("YYYY-MM-DD");
    },

    initDt2() {
      let self = this;
      $("#myTable2").DataTable({
        initComplete: function () {
          this.api()
            .columns()
            .every(function () {
              var column = this;

              var select = $('<select><option value="">All</option></select>')
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());

                  column.search(val ? "^" + val + "$" : "", true, false).draw();
                });
              let arr = [];
              let sortedArr = [];
              column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                  var myVal = $(d).text();
                  arr.push(myVal);
                });

              sortedArr = arr.sort((a, b) =>
                a.localeCompare(b, navigator.languages[0] || navigator.language, {
                  numeric: true,
                  ignorePunctuation: true,
                })
              );

              for (let [idx, ds] of sortedArr.entries()) {
                select.append('<option value="' + ds + '">' + ds + "</option>");
              }
            });
        },
      });
    },
  },
};
</script>

<style scoped>
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important;
}
.markitintel {
  background-color: #c7e0ff !important;
}
.markitsnap {
  background-color: #ffd0f5 !important;
}
.markitna {
  background-color: #edf2fb !important;
}
.markittek {
  background-color: #fff0ce !important;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
  margin-bottom: 0;
  line-height: 31px;
}
.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}
.hint {
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
}
.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 9;
}
.amd-legend i {
  width: fit-content;
}
.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}
.legending {
  display: inline-block;
  margin-right: 19px;
}
#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}
.mycols:first-child {
  padding-right: 2px !important;
}
.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
input.filval,
button.filval {
  border-radius: 0;
  padding: 6px;
  height: 30px;
}
input.filval {
  padding-top: 5px;
}
button.filval {
  padding-top: 3px;
}
.filter .row {
  justify-content: center;
}
.filter select,
input.filval {
  border: 1px solid silver;
}
</style>
